import { StepOneSpecialistValidation } from "../RegisterValidation";
import { useState } from "react";
import "./signup.css";
import CustomInput from "../../ui/custom-inputs/CustomInput";
function SpecialistStepOne({ setStep, formData, handleChange }) {
  const [formErrors, setFormErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = StepOneSpecialistValidation(formData);

    if (Object.keys(err).length === 0) {
      setFormErrors(err);
      setStep(2);
    } else {
      setFormErrors(err);
    }
  };

  return (
    <>
      <form
        className=' border p-3 shadow-md rounded-md text-sm w-[20rem] sm:w-[27rem] bg-[#bbb9b4]'
        onSubmit={handleSubmit}
      >
        <div className=' flex justify-between'>
          <h4 className=' text-white text-sm'> خطوة 1 من اصل 2</h4>
          <h4 className=' text-white'> بيانات الاخصائي العامة</h4>
        </div>
        <div className='w-full bg-gray-200 rounded-full h-1 relative mt-3'>
          <div className='bg-primary h-1 rounded-full  absolute right-0 w-1/2 '></div>
        </div>
        <br />
        <label className=' flex flex-col items-end text-white'>
          الاسم الكامل
          <CustomInput
            required
            type='text'
            dir='rtl'
            className=' text-black  placeholder:text-sm w-full border-2 p-1  h-10 pr-3 rounded-lg'
            placeholder='ادخل الاسم الثلاثي'
            
            onChange={handleChange}
            name='fullName'
            value={formData.fullName || ""}
          />{" "}
          {formErrors?.fullName && (
            <>
              <p className=' text-xs text-red-500'>{formErrors?.fullName}</p>
            </>
          )}
        </label>
        <div className=' flex mt-3 mb-3 md:flex-row flex-col'>
          <label className=' flex flex-col text-end text-white '>
            رقم الجوال
            <CustomInput
              required
              className=' text-black placeholder:text-sm  border-2 md:w-48 max-w-full p-1 h-10 pr-3 rounded-lg'
              type='tel'
              dir='rtl'
              placeholder='ادخل رقم جوال فعال'
              
              onChange={handleChange}
              name='phone'
              value={formData.phone || ""}
            />{" "}
            {formErrors?.phone && (
              <>
                <p className=' text-xs text-red-500 w-44'>{formErrors?.phone}</p>
              </>
            )}
          </label>
          <label className=' flex flex-col text-end md:ml-4 text-white'>
            البريد الالكتروني{" "}
            <CustomInput
              required
              className=' text-black placeholder:text-sm border-2 md:w-48 w-full h-10 p-1 pr-3 rounded-lg  '
              type='email'
              dir='rtl'
              placeholder='ادخل بريد الكتروني فعال'
              
              onChange={handleChange}
              name='email'
              value={formData.email || ""}
            />{" "}
            {formErrors?.email && (
              <>
                <p className=' text-xs text-red-500'>{formErrors?.email}</p>
              </>
            )}
          </label>
        </div>
        <div className=' flex mt-3 mb-3 md:flex-row flex-col'>
          <label className=' flex flex-col text-end   '>
            <div className='  relative md:w-48 w-full flex items-center justify-center border-2 p-1  h-10 pr-3 rounded-lg'>
              <div className='flex justify-center items-center'>
                <span className=' mr-1 text-white'> أنثى</span>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='24'
                  viewBox='0 0 34.496 38.737'
                >
                  <g
                    id='noun-female-1100926'
                    transform='translate(7.193 -33.983) rotate(30)'
                  >
                    <path
                      id='Path_310193'
                      data-name='Path 310193'
                      d='M34.356,45.382V50.94H32.012a1.028,1.028,0,0,0,0,2.056h2.344v3a1.028,1.028,0,0,0,2.056,0V53h2.344a1.028,1.028,0,0,0,0-2.056H36.412V45.382a10.054,10.054,0,1,0-2.056,0Zm1.028-18a8,8,0,1,1-8,8,8,8,0,0,1,8-8Z'
                      transform='translate(0 0)'
                      fill=''
                      stroke='#fff'
                      strokeWidth='0.9'
                    />
                  </g>
                </svg>
              </div>
              <input
                className='absolute left-2 top-2 w-4 h-4  '
                type='radio'
                dir='rtl'
                name='gender'
                value={"female"}
                onChange={handleChange}
                checked={formData.gender === "female"}
              />{" "}
              <span className='radio-check'></span>
            </div>
          </label>
          <label className=' flex flex-col text-end '>
            <div className='  relative md:w-48 w-full  flex items-center justify-center border-2 p-1  h-10 pr-3 rounded-lg md:ml-4 sm:mt-0 mt-2'>
              <div className=' flex justify-center items-center '>
                <span className=' mr-1 text-white'> ذكر</span>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                >
                  <g id='noun-male-1070605' transform='translate(-6 -6)'>
                    <g
                      id='Group_127723'
                      data-name='Group 127723'
                      transform='translate(6 6)'
                    >
                      <path
                        id='Path_310192'
                        data-name='Path 310192'
                        d='M22.858,958.362a.546.546,0,1,0,.051,1.091h5.224L21.886,965.7a9.315,9.315,0,1,0,.784.767l6.239-6.247v5.233a.545.545,0,0,0,1.091,0v-6.545a.546.546,0,0,0-.545-.545h-6.6Zm-7.312,6a8.454,8.454,0,1,1-8.455,8.454A8.446,8.446,0,0,1,15.545,964.362Z'
                        transform='translate(-6 -958.362)'
                        fill='#454f4f'
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <input
                required
                className='absolute left-2 top-2 w-4 h-4  '
                type='radio'
                dir='rtl'
                name='gender'
                value={"male"}
                id='male'
                onChange={handleChange}
                checked={formData.gender === "male"}
              />
              <div className='radio-check'></div>
            </div>
          </label>
        </div>
        <div className=' flex mt-3 mb-3 md:flex-row flex-col'>
          <label className='w-full flex flex-col text-end md:mr-4 text-white '>
            تأكيد كلمة المرور
            <CustomInput
              required
              type='password'
              placeholder='تأكد من تطابق كلمة السر'
              dir='rtl'
              name='confirmPassword'
              
              onChange={handleChange}
              value={formData.confirmPassword || ""}
            />{" "}
            {formErrors?.confirmPassword && (
              <>
                <p className=' text-xs text-red-500'>
                  {formErrors?.confirmPassword}
                </p>
              </>
            )}
          </label>
          <label className='w-full flex flex-col text-end text-white'>
            كلمة المرور
            <CustomInput
              required
              type='password'
              dir='rtl'
              placeholder='كلمة سر اكثر من 8 خانات'
              name='password'
              
              onChange={handleChange}
              value={formData.password || ""}
            />{" "}
            {formErrors?.password && (
              <>
                <p className=' text-xs text-red-500  w-48'>
                  {formErrors?.password}
                </p>
              </>
            )}
          </label>
        </div>

        <br />
        <input
          value='حفظ واستكمال بيانات أخرى'
          type='submit'
          className=' cursor-pointer text-center border-2 bg-primary w-full text-white rounded-xl h-10'
        />
      </form>
    </>
  );
}

export default SpecialistStepOne;
